import { Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { motion } from 'motion/react';
import { TriangleMotif } from '@/components/brand/triangle-motif';
import { buttonVariants } from '@/components/ui/button-variants';
import { cn } from '@/lib/cn';

export function NotFoundPage({ fullscreen }: { fullscreen?: boolean }) {
  return (
    <div
      className={cn(
        'relative flex flex-col items-center justify-center overflow-hidden px-6 text-center',
        fullscreen ? 'min-h-dvh bg-bg' : 'py-24',
      )}
    >
      <TriangleMotif className="text-brand/15" />
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="relative bg-linear-to-br from-brand to-accent bg-clip-text font-display text-8xl font-bold text-transparent"
      >
        404
      </motion.p>
      <h1 className="relative mt-4 font-display text-2xl font-semibold text-fg">
        This page took a different route
      </h1>
      <p className="relative mt-2 max-w-md text-sm text-fg-muted">
        The page you’re looking for doesn’t exist or you don’t have access to it.
      </p>
      <Link to="/" className={cn(buttonVariants({ variant: 'primary' }), 'relative mt-6')}>
        <ArrowLeft aria-hidden /> Back to home
      </Link>
    </div>
  );
}
